import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import styles from "./Reports.module.css";
import ReportsMenu from "../menus/ReportsMenu";
import React from "react";

function Reports() {
  return (
    <main className={styles.main}>
      <Sidebar>
        <ReportsMenu />
      </Sidebar>

      <Outlet />
    </main>
  );
}

export default Reports;
